import { render } from "./DappInfo.vue?vue&type=template&id=2ba497aa&scoped=true&ts=true"
import script from "./DappInfo.vue?vue&type=script&lang=ts"
export * from "./DappInfo.vue?vue&type=script&lang=ts"

import "./DappInfo.vue?vue&type=style&index=0&id=2ba497aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba497aa"]])

export default __exports__